﻿import { IRccapAdditionalQuestion } from './rccap-additional-question';

export interface IRccapPositionDetail {
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    donorId: number;
    donorAlias: string;
    donorCenterId: number;
    donorCenterAlias: string;
    remoteDonorCenterId: number;
    remoteDonorCenterAlias: string;
    recipientId: number;
    recipientAlias: string;
    recipientAbo: string;
    recipientPmpC: number;
    recipientCpra: number;
    recipientDonorAbo: string;
    recipientCenterId: number;
    recipientCenterAlias: string;
    donorCenterLiaison: number;
    recipientCenterLiaison: number;
    rccapManager: number;
    transplantsImpacted: number;
    exmRequestedDate: string;
    failDate: string;
    targetSurgeryDate: string;
    dueDate: string;
    clusterStatusId: number;
    matchHistoryType: number;
    matchHistoryIsAccepted: boolean;
    matchHistoryCorrectiveAction: string;
    matchHistoryRejectionReason: number;
    matchHistoryRejectionReasonText: string;
    matchHistoryRootCause: number;
    matchHistoryAdditionalComments: string;
    matchOfferDate: string;
    matchOfferDecision: string;
    matchHistorySignOff: string;
    issueDescription: string;
    additionalQuestions: IRccapAdditionalQuestion[];
    rootCausePrimary: number;
    rootCauseSecondary: number;
    acceptedResponse: string;
    additionalComments: string;
    avoidable: number;
    billable: number;
    satisfactoryResponse: number;
    centerCorrectiveAction: string;
    responder: string;
    responseDate: string;
    correctiveActionPrimary: number;
    correctiveActionSecondary: number;
    rccapPhase: number;
    requester: number;
    currentStatus: number;
}
